import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

import { ProjectContextService } from '@services/project-context/project-context.service';
import { ProjectOption } from '@constants/projects.constants';
import { FilterStateService } from '@services/filter-state/filter-state.service';
import { StructureService } from '@services/structure/structure.service';

@Component({
  selector: 'app-select-project',
  templateUrl: './select-project.component.html',
  styleUrl: './select-project.component.scss'
})
export class SelectProjectComponent implements OnInit, OnDestroy {
  loading = true;
  projects: ProjectOption[] = [];
  selectedProjectId: string | null = null;

  private readonly subs = new Subscription();

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly translocoSrv: TranslocoService,
    private readonly projectContext: ProjectContextService,
    private readonly filterStateService: FilterStateService,
    private readonly structureService: StructureService
  ) {
    // Initialize from persisted state synchronously.
    this.projects = this.projectContext.getAllowedProjectsSnapshot();
    this.selectedProjectId = this.projectContext.getSelectedProjectIdSnapshot();
  }

  ngOnInit(): void {
    this.subs.add(
      this.projectContext.allowedProjects$.subscribe((projects) => {
        this.projects = projects;
        this.loading = false;

        if (!this.projectContext.getSelectedProjectIdSnapshot() && projects.length === 1) {
          this.selectProject(projects[0].projectId);
        }
      })
    );

    this.subs.add(
      this.projectContext.selectedProjectId$.subscribe((id) => {
        this.selectedProjectId = id;
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  selectProject(projectId: string): void {
    this.projectContext.selectProject(projectId);

    // Clear structure caches so the next screens load the correct project immediately.
    this.structureService.clearCache();

    // Load availability for the selected project (also persists the projectId in FilterStateService).
    this.filterStateService.loadAvailability(projectId).subscribe({
      error: () => {
        // error state is stored in FilterStateService
      }
    });

    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    this.router.navigateByUrl(returnUrl && returnUrl.startsWith('/') ? returnUrl : '/home');
  }

  getTitle(): string {
    // Keep it simple; translations can be added later if needed.
    return this.translocoSrv.translate('select-project.title');
  }
}
